// @flow

/**
@deprecated It will be removed in 6 months 04-28-2026. Use Floating instead.
*  */
export const HorizontalPositionElement = {
    LEFT: 'LEFT',
    CENTER: 'CENTER',
    RIGHT: 'RIGHT'
};

/**
 @deprecated It will be removed in 6 months 04-28-2026. Use Floating instead.
 */
export const VerticalPositionElement = {
    TOP: 'TOP',
    CENTER: 'CENTER',
    BOTTOM: 'BOTTOM'
};
